module.exports = "<div class=\"ot-facebook-login container-fluid\">\n  <div class=\"row\">\n    <button class=\"btn btn-primary ot-full-container\" ng-click=\"vm.loginWithFacebook()\"><span class=\"icon-facebook\"></span>{{\"LOGIN.FACEBOOK\" | translate}}</button>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/facebookLogin.html
 ** module id = 282
 ** module chunks = 1
 **/